import React, { useEffect, useState } from "react";
import { TextField, Grid, MenuItem,
  InputAdornment, IconButton } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useDispatch, useSelector } from "react-redux";
import CompanyVeiwController from "../../../redux/actions/companyApiActions";
import { getUserInfoFromToken } from "../../../utils/authUtils";
import { inputSx, mobileInputSx } from "../../../components/auth/authTheme";

const BasicInformationForm = ({ formik, isMobile = false, isEdit }) => {
  const { values, errors, touched, handleChange, handleBlur } = formik;
  const fieldSx = isMobile ? mobileInputSx : inputSx;
  const fieldCols = isMobile ? 12 : 6;

  const dispatch = useDispatch();
  const { getCompanies } = CompanyVeiwController();
  const { companies } = useSelector((state) => state.company);
  const [userType, setUserType] = useState(null);

  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  useEffect(() => {
    dispatch(getCompanies());
  }, [dispatch]);

  useEffect(() => {
    const { userType: type } = getUserInfoFromToken();
    setUserType(type);
  }, []);

  return (
    <Grid container spacing={isMobile ? 2 : 2.5}>
      {userType === "Admin" && (
        <Grid item xs={12}>
          <TextField
            select
            fullWidth
            label="Company"
            name="company_id"
            value={values.company_id}
            onChange={handleChange}
            onBlur={handleBlur}
            required
            error={touched.company_id && Boolean(errors.company_id)}
            helperText={touched.company_id && errors.company_id}
            sx={fieldSx}
          >
            <MenuItem value="">Select Company</MenuItem>
            {companies.map((c) => (
              <MenuItem key={c.id} value={c.id}>
                {c.company_name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      )}
      <Grid item xs={12} sm={fieldCols}>
        <TextField
          fullWidth
          label="First Name"
          name="first_name"
          value={values.first_name}
          onChange={handleChange}
          onBlur={handleBlur}
          required
          error={touched.first_name && Boolean(errors.first_name)}
          helperText={touched.first_name && errors.first_name}
          sx={fieldSx}
        />
      </Grid>

      <Grid item xs={12} sm={fieldCols}>
        <TextField
          fullWidth
          label="Last Name"
          name="last_name"
          value={values.last_name}
          onChange={handleChange}
          sx={fieldSx}
        />
      </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Email"
            name="email"
            type="email"
            inputMode="email"
          autoComplete="email"
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.email && Boolean(errors.email)}
            helperText={touched.email && errors.email}
          />
        </Grid>
        
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Mobile Number"
            name="mobile_number"
            value={values.mobile_number}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.mobile_number && Boolean(errors.mobile_number)}
            helperText={touched.mobile_number && errors.mobile_number}
          />
        </Grid>
        
        <Grid item xs={12} sm={12}>
          <TextField
            fullWidth
            label={isEdit ? "New Password (Optional, leave blank to keep current)" : "Set Password (Optional, auto-generated if blank)"}
            name="password"
            type={showPassword ? "text" : "password"}
            value={values.password}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.password && Boolean(errors.password)}
            helperText={touched.password && errors.password}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
    </Grid>
  );
};

export default BasicInformationForm;
